export const ClientTeamInvitations = (json: IClientTeamInvitations): IClientTeamInvitationsModel => {
	const { team_id, created_at, updated_at, ...rest } = json

	return {
		...rest,
		teamId: team_id,
		createdAt: created_at ? new Date(created_at) : null,
		updatedAt: updated_at ? new Date(updated_at) : null,
	}
}

export const ClientTeamClientProfile = (json: IClientTeamClientProfile): IClientTeamClientProfileModel => {
	const {
		client_id,
		first_name,
		last_name,
		marketing_consent,
		mail_communication_consent,
		sms_communication_consent,
		onboarding_completed,
		birth_date,
		diet_expectation,
		weight_goal,
		created_at,
		updated_at,
		...rest
	} = json

	return {
		...rest,
		clientId: client_id,
		firstName: first_name,
		lastName: last_name,
		marketingConsent: marketing_consent,
		mailCommunicationConsent: mail_communication_consent,
		smsCommunicationConsent: sms_communication_consent,
		onboardingCompleted: onboarding_completed,
		birthDate: birth_date ? new Date(birth_date) : null,
		dietExpectation: diet_expectation,
		weightGoal: weight_goal,
		createdAt: created_at ? new Date(created_at) : null,
		updatedAt: updated_at ? new Date(updated_at) : null,
	}
}

export const ClientTeamOwner = (json: IClientTeamOwner): IClientTeamOwnerModel => {
	const { email_verification_token, email_verified_at, password_reset_token, phone_number, ...rest } = json

	return {
		...rest,
		emailVerifiedAt: email_verified_at,
		emailVerificationToken: email_verification_token,
		passwordResetToken: password_reset_token,
		phoneNumber: phone_number,
	}
}

export const ClientTeamMemberships = (json: IClientTeamMemberships): IClientTeamMembershipsModel => {
	const { team_id, client_id, created_at, updated_at, client_profile, ...rest } = json

	return {
		...rest,
		teamId: team_id,
		clientId: client_id,
		createdAt: created_at ? new Date(created_at) : null,
		updatedAt: updated_at ? new Date(updated_at) : null,
		clientProfile: ClientTeamClientProfile(client_profile),
	}
}

export const ClientTeam = (json: IClientTeam): IClientTeamModel => {
	const { client_id, invitation_code, memberships, team_invitations, owner_profile, owner, ...rest } = json

	return {
		...rest,
		clientId: client_id,
		invitationCode: invitation_code,
		memberships: memberships.map(m => ClientTeamMemberships(m)),
		teamInvitations: team_invitations.map(t => ClientTeamInvitations(t)),
		ownerProfile: ClientTeamClientProfile(owner_profile),
		owner: ClientTeamOwner(owner),
	}
}
